/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMenuOrder = createReactComponent("menu-order", "IconMenuOrder", [
  ["path", { d: "M4 10h16", key: "svg-0" }],
  ["path", { d: "M4 14h16", key: "svg-1" }],
  ["path", { d: "M9 18l3 3l3 -3", key: "svg-2" }],
  ["path", { d: "M9 6l3 -3l3 3", key: "svg-3" }]
]);

export { IconMenuOrder as default };
//# sourceMappingURL=IconMenuOrder.js.map
